import {atomIconColors} from '@s-ui/react-atom-icon'
import CheckIcon from '@adv-mt/mt-svg-icons/lib/Check'
import TriangleWarningOutlineIcon from '@adv-mt/mt-svg-icons/lib/TriangleWarningOutline'

export const BASE_CLASS = 'mt-CardCarfax'

export const ICON_TYPES = {
  OK: 'ok',
  WARNING: 'warning'
}

export const ICONS = {
  [ICON_TYPES.OK]: {color: atomIconColors.success, icon: CheckIcon},
  [ICON_TYPES.WARNING]: {color: atomIconColors.alert, icon: TriangleWarningOutlineIcon}
}
